module.exports = __webpack_public_path__ + "static/csv-c8134dfd958bd43695ef4a8f7106bbdc.png";